import { Logo, Mark } from "@wirevod/app-core";
import { Outlet } from "react-router";
import styles from "./AuthLayout.module.css";

/** Sign-in pages: the brand on a night panel, the form on paper. */
export function AuthLayout() {
  return (
    <div className={styles.layout}>
      <aside className={styles.panel} aria-hidden="true">
        <span className={styles.panelLogo}>
          <Logo />
        </span>
        <div className={styles.art}>
          <Mark size={200} />
          <span className={styles.wires}>
            <i />
            <i />
            <i />
            <i />
          </span>
        </div>
        <p className={styles.quote}>
          Intelligent video for education. Protected, fast and lean on every screen.
        </p>
      </aside>
      <main className={styles.main}>
        <div className={styles.mobileLogo}>
          <Logo />
        </div>
        <div className={styles.form}>
          <Outlet />
        </div>
        <footer className={styles.footer}>
          <a href="https://wirevod.online/security/">Security</a>
          <a href="https://wirevod.online/docs/">Documentation</a>
          <a href="mailto:support@wirevod.online">Support</a>
        </footer>
      </main>
    </div>
  );
}
